const _identityVerify = `^[0-9a-zA-Z]{1,50}$`
const _emailVerify = `^[a-zA-Z0-9.!#$%&'*+\\/=?^_\`{|}~-]+@[a-zA-Z0-9]
(?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$`
const _phoneVerify = `^1(3|4|5|6|7|8|9)\\d{9}$`
const _landlinePhoneVerify = `(^([0-9]{3,4}-)?[0-9]{7,8}$)|(^1(3|4|5|6|7|8|9)\\d{9}$)`
const _carNumVerify = `^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领]{1}[A-HJ-NP-Z]{1}[A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳]{1}$`
const _numberVerify = `^\\d+$|^\\d*\\.\\d+$`
const _integerVerify = `^\\d+$`
const _nameEnVerify = `^[a-zA-Z1-9\\.\\s\\,\\(\\)\\-]{1,177}$`
const _socialCodeVerify = `^[0-9A-Z]{18}$`
const _socialCodeVerifyEn = `^[0-9a-zA-Z]+$`
const _driverLicenseVerify = `^[0-9a-zA-Z]{1,32}$`
const _registerCapitalVerify = `^(^[1-9](\\d+)?(\\.\\d{1,3})?$)|(^\\d\\.\\d{1,3}$)`
const _twoPointVerify = `^(^[1-9](\\d+)?(\\.\\d{1,2})?$)|(^\\d\\.\\d{1,2}$)`
const _commanderCodeVerify = `^[0-9]{1,10}$`
const _dateVerify = `^\\d{4}-\\d{2}-\\d{2}$`
const _tenIntegerVerify = `^[1-9](\\d{0,9})$`
const _carLwhVerify = `(^[1-9]\\d(\\.\\d{1,3})?$)|(^\\d(\\.\\d{1,3})?$)`
const _carInnerLwhVerify = `(^[1-9]\\d(\\.\\d{1,2})?$)|(^\\d(\\.\\d{1,2})?$)`
const _onlyTwelveIntegerVerify = `^[0-9]\\d{11}$`
const _sixTwelveIntegerVerify = `^[0-9]\\d{5,11}$`
const _sixTwentyIntegerVerify = `^[0-9]\\d{5,19}$`
const _eightTwelveIntegerVerify = `^[0-9]\\d{7,11}$`

//身份证(新)
export const idCardReg = /^[1-9]\d{5}(19|20)\d{2}(0\d|1[0-2])([0-2]\d|3[0-1])\d{3}[0-9Xx]$/

// 身份证
export const identityVerify = new RegExp(_identityVerify.replace(/(\r\n)|(\n)/g, ''))

// 邮件
export const emailVerify = new RegExp(_emailVerify.replace(/(\r\n)|(\n)/g, ''))

// 联系电话
export const phoneVerify = new RegExp(_phoneVerify)

// 座机电话
export const landlinePhoneVerify = new RegExp(_landlinePhoneVerify)

// 车牌号
export const carNumVerify = new RegExp(_carNumVerify.replace(/(\r\n)|(\n)/g, ''))

// 数字
export const numberVerify = new RegExp(_numberVerify.replace(/(\r\n)|(\n)/g, ''))

// 正整数
export const integerVerify = new RegExp(_integerVerify.replace(/(\r\n)|(\n)/g, ''))

// 正/负整数
export const pnIntegerVerify = /^(\-|\+?)\d+$/

// 英文名（公司名）
export const nameEnVerify = new RegExp(_nameEnVerify.replace(/(\r\n)|(\n)/g, ''))

// 统一社会信用代码/营业执照号/税务登记号
export const socialCodeVerify = new RegExp(_socialCodeVerify.replace(/(\r\n)|(\n)/g, ''))

// 统一社会信用代码/营业执照号/税务登记号（英文）
export const socialCodeVerifyEn = new RegExp(_socialCodeVerifyEn.replace(/(\r\n)|(\n)/g, ''))

// 驾驶证号
export const driverLicenseVerify = new RegExp(_driverLicenseVerify.replace(/(\r\n)|(\n)/g, ''))

// 注册资金 >0 保留三位小数
export const registerCapitalVerify = new RegExp(_registerCapitalVerify.replace(/(\r\n)|(\n)/g, ''))

// >0 保留两位小数
export const twoPointVerify = new RegExp(_twoPointVerify.replace(/(\r\n)|(\n)/g, ''))

// 福佑车长代码
export const commanderCodeVerify = new RegExp(_commanderCodeVerify.replace(/(\r\n)|(\n)/g, ''))

// 日期 YYYY-MM-DD格式
export const dateVerify = new RegExp(_dateVerify.replace(/(\r\n)|(\n)/g, ''))

// 车重 > 0 最多10位整数
export const tenIntegerVerify = new RegExp(_tenIntegerVerify.replace(/(\r\n)|(\n)/g, ''))

// 外径长、宽、高 2位整数，3位小数
export const carLwhVerify = new RegExp(_carLwhVerify.replace(/(\r\n)|(\n)/g, ''))

// 内径长、宽、高 2位整数，2位小数
export const carInnerLwhVerify = new RegExp(_carInnerLwhVerify.replace(/(\r\n)|(\n)/g, ''))

// 12位数字
export const onlyTwelveIntegerVerify = new RegExp(_onlyTwelveIntegerVerify.replace(/(\r\n)|(\n)/g, ''))

// 6-12位数字
export const sixTwelveIntegerVerify = new RegExp(_sixTwelveIntegerVerify.replace(/(\r\n)|(\n)/g, ''))
// 6-20位数字
export const sixTwentyIntegerVerify = new RegExp(_sixTwentyIntegerVerify.replace(/(\r\n)|(\n)/g, ''))

// 8-12位数字
export const eightTwelveIntegerVerify = new RegExp(_eightTwelveIntegerVerify.replace(/(\r\n)|(\n)/g, ''))

// 文件名后缀集合
export const fileSuffixList = ['jpg', 'bmp', 'gif', 'ico', 'pcx', 'jpeg', 'tif', 'png', 'raw', 'tga', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'txt', 'zip', 'rar']
